import Axios from 'axios'

import NPSApi from '@modules/admin/nps/nps.api'
import CompanyApi from '@modules/admin/companies/company.api'
import CampaignApi from '@modules/admin/campaigns/campaign.api'
import CustomersApi from '@modules/admin/customers/customer.api'
import { refreshTokenInterceptor } from '@services/APIInterceptors/refreshTokenInterceptors'

class CoreV2Singleton {
  constructor() {
    const httpConfig = {
      baseURL: import.meta.env.VITE_REACT_APP_URL_CORE_V2,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)
    console.info(`Axios instance CORE V2: ${this.client.defaults.baseURL}`)

    this.client.interceptors.request.use(refreshTokenInterceptor)

    //ADMIN CALLS
    this.nps = new NPSApi(this.client)
    this.companies = new CompanyApi(this.client)
    this.campaigns = new CampaignApi(this.client)
    this.customers = new CustomersApi(this.client, 'api/customers')
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

const CoreV2 = CoreV2Singleton.instance
export default CoreV2
